export function appVersion(
  version?: string,
  commit?: string,
  repository?: string,
) {
  if (!version || !commit || !repository) {
    return null;
  }

  return {
    label: `v${version} · ${commit.slice(0, 7)}`,
    href: `${repository}/commit/${commit}`,
  };
}
